module.exports = __webpack_public_path__ + "img/nanwa1.8fc1fb84.png";